import React, { Component } from 'react';
import { FormGroup, FormControl, Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { users } from '../../../store/actions';
import { setNewPassword } from '../../../utils/apputils';
import logo from '../../../static/images/logo-countpicula-dark.png';
import Spinner from '../../Spinner/Spinner.js';
import { passwordMinLength } from '../../../utils/user_config';

const mapStateToProps = state => ({
  status: state.users.status,
  email: state.users.email,
  error: state.users.error
});

class NewPasswordForm_Class extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.back = this.back.bind(this);
    this.state = {
      code: '',
      password: '',
      passwordValid: false
    };
  }

  onChange({ target: { id, value } }) {
    if (id === 'password') {
      const valid = value.length > passwordMinLength;
      this.setState({ passwordValid: valid });
    }
    this.setState({
      [id]: value
    });
  }

  back() {
    const { dispatch } = this.props;
    dispatch(users.prompt_recovery_email());
  }

  onSubmit(e) {
    e.preventDefault();
    const { dispatch, email } = this.props;
    const { code, password } = this.state;
    setNewPassword(email, code, password, dispatch);
  }

  getValidationState() {
    const {
      password: { length }
    } = this.state;
    if (length > passwordMinLength) {
      return 'success';
    } else if (length > 0) {
      return 'error';
    }
    return null;
  }

  render() {
    const { status, error } = this.props;
    const { code, password, passwordValid } = this.state;
    return (
      <form onSubmit={this.onSubmit}>
        <span>
          Enter the code we&rsquo;ve sent you and select a new password.
        </span>
        <div className="tint-box">
          <FormGroup controlId="code">
            <FormControl
              type="text"
              value={code}
              placeholder="Authentication code"
              onChange={this.onChange}
              required
            />
            <FormControl.Feedback />
          </FormGroup>
          <FormGroup
            validationState={this.getValidationState()}
            controlId="password"
          >
            <FormControl
              type="password"
              value={password}
              placeholder="New password"
              onChange={this.onChange}
              required
            />
          </FormGroup>
        </div>
        <br />
        {(status === users.types.SENT_RECOVERY_EMAIL ||
          status === users.types.SETTING_NEW_PASSWORD_FAILED) && (
          <div>
            <Button onClick={this.back} className="btn-bevel">
              Back
            </Button>
            <Button
              bsStyle="primary"
              className="pull-right btn-bevel"
              type="submit"
              disabled={!passwordValid}
            >
              Send
            </Button>
          </div>
        )}
        {status === users.types.SETTING_NEW_PASSWORD_FAILED && (
          <div>
            <span className="error">{error}</span>
            <br />
          </div>
        )}
        {status === users.types.SETTING_NEW_PASSWORD && (
          <Spinner type="regular" />
        )}
      </form>
    );
  }
}
const NewPasswordForm = connect(mapStateToProps)(NewPasswordForm_Class);

class NewPassword extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { dispatch } = this.props;
    dispatch(users.logout());
  }

  render() {
    const { status } = this.props;
    const show = [
      users.types.SENT_RECOVERY_EMAIL,
      users.types.SETTING_NEW_PASSWORD,
      users.types.SETTING_NEW_PASSWORD_FAILED
    ].includes(status);

    return (
      <React.Fragment>
        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <h2 className="modal-title" id="m_registerLabel">
              <span>Password reset</span>
            </h2>
            <img
              className="logo-img"
              src={logo}
              width="117"
              height="75"
              alt=""
            />
          </Modal.Header>
          <Modal.Body>
            <NewPasswordForm close={this.handleClose} />
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(NewPassword);



// WEBPACK FOOTER //
// ./src/comps/Navbar/components/NewPassword.js